export const PersonInfoStore = {
  donor_name: '',
  donor_phone: '',
  donor_email: '',
  receive_notify: '1',
  btnActive: false,
};
